export const eanObfuscator = (s, offset) => {
  return s
    .split("")
    .map((c, index) => {
      const newInt = (parseInt(c) + index + offset) % 10;
      return String.fromCharCode(97 + index + newInt);
    })
    .join("");
}

export const getJoursIndispo = (joursRetrait) => {
  if (!joursRetrait) {
    return null;
  }
  const jours =
    [...joursRetrait]
      .sort((a, b) => b.jour_numero - a.jour_numero)
      .filter((jour) => !jour.disponible)
      .map(
        ({ jour_texte: [initial, ...rest] }) =>
          initial.toUpperCase() + rest.join("")
      ) || [];

  if (!jours || jours.length === 0) {
    return null;
  }

  if (jours.length === 1) {
    return `${jours[0]}`;
  }

  const [last, ...rest] = jours;
  rest.reverse();

  return `${rest.join(", ")} et ${last}`;
}